import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';

import type { ListStyleProps, TransitionProps } from 'common/theme/system-utilities';
import { listStyle, transition } from 'common/theme/system-utilities';
import { Flex } from '../Flex';
import SwipeHandler from './SwipeHandler';

interface CarouselTrackWrapperProps {
  children: React.ReactNode;
  currentIndex: number;
  slideWidth: number;
  gap: number;
  previousSlide: () => void;
  nextSlide: () => void;
  disableTransition?: boolean;
}

export const CarouselTrack = styled(Flex)<
  { translateX?: number } & TransitionProps & ListStyleProps
>`
  transform: translateX(${props => (props.translateX ? `-${props.translateX}px` : '0')});
  ${listStyle};
  ${transition};
`;

const carouselTrackStyle: ComponentProps<typeof CarouselTrack> = {
  height: 'auto',
  transition: 'transform 100ms ease-in-out',
  listStyle: 'none',
  p: 'sp_0',
  m: 'sp_0',
};

const CarouselTrackWrapper = ({
  children,
  currentIndex,
  slideWidth,
  gap,
  previousSlide,
  nextSlide,
  disableTransition = false,
}: CarouselTrackWrapperProps) => {
  return (
    <SwipeHandler onSwipeRight={previousSlide} onSwipeLeft={nextSlide}>
      <CarouselTrack
        {...carouselTrackStyle}
        data-testid="carousel-track"
        aria-live="polite"
        gap={`${gap}px`}
        translateX={currentIndex * (slideWidth + gap)}
        {...(disableTransition && { transition: 'none' })}
      >
        {children}
      </CarouselTrack>
    </SwipeHandler>
  );
};

export default CarouselTrackWrapper;
